import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_main, {
      style: {
        "margin-top": "-25px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form, {
        model: $data.form,
        ref: "form",
        rules: $data.rules,
        "status-icon": "",
        "label-width": "160px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "当前印章："
        }, {
          default: _withCtx(() => [_createVNode(_component_el_image, {
            src: $data.src,
            style: {
              "width": "100px",
              "height": "100px"
            }
          }, null, 8, ["src"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "印章名",
          prop: "sealName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.sealName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.sealName = $event),
            placeholder: "请输入印章名",
            onkeyup: "this.value=this.value.replace(/[, ]/g,'')",
            style: {
              "width": "300px"
            },
            clearable: "",
            autocomplete: "off",
            "show-word-limit": "",
            required: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "上传印章",
          "status-icon": "",
          "label-width": "160px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "avatar-uploader",
            action: this.ip + '/detection/saveSealUrl',
            "show-file-list": false,
            "on-success": $options.uploadSuccess,
            "before-upload": $options.beforeAvatarUpload,
            ref: "upload"
          }, {
            default: _withCtx(() => [$data.imageUrl ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: $data.imageUrl,
              class: "avatar"
            }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("i", _hoisted_3))]),
            _: 1
          }, 8, ["action", "on-success", "before-upload"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            style: {
              "margin-top": "20px"
            },
            type: "primary",
            plain: "",
            onClick: _cache[1] || (_cache[1] = $event => $options.Submit('form'))
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("确定上传", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]),
      _: 1
    })]),
    _: 1
  })]);
}